import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { PaginationComponent } from 'ngx-bootstrap';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ArrayHelper } from '../../../models/helpers/array-helper';
import { ConfirmDeleteModalComponent } from '../../core/components/delete-modal/confirm-delete-modal-component';
import { BaseComponent } from '../../core/components/bases/base-component';
export class SiteTableComponent extends BaseComponent {
    constructor(router, route, userService) {
        super();
        this.router = router;
        this.route = route;
        this.userService = userService;
        this.pageSites = [];
        this._sites = [];
        this.siteDeleted = new EventEmitter();
        this.columns = [
            { key: 'siteNo', title: 'Planting Site #', property: site => site.code },
            { key: 'name', title: 'Name of Site', property: site => site.title },
            { key: 'country', title: 'Country', property: site => site.country },
            { key: 'region', title: 'Region', property: site => site.region },
            { key: 'year', title: 'Year', property: site => new Date(site.plantingDate).getFullYear(), textRight: true },
            { key: 'photo', title: 'Photo Collection', property: site => site.photoCollectionCount, textRight: true },
            { key: 'planted', title: 'Planted Trees', property: site => site.totalTrees, textRight: true },
            { key: 'available', title: 'Available Trees', property: site => site.availableTrees, textRight: true },
        ];
        this.sortColumn = this.columns[0];
        this.sortAsc = true;
        this.scrollConfig = {
            suppressScrollX: false,
            suppressScrollY: true
        };
    }
    set sites(sites) {
        this._sites = sites;
        this.pagination.selectPage(1);
        this.sortByChanged();
    }
    ngOnInit() {
        this.getCurrentUser();
        this.route.queryParamMap
            .pipe(map(map => map.get('page') || '1'), distinctUntilChanged())
            .subscribe(page => {
            this.pagination.selectPage(parseInt(page));
        });
        this.pagination.pageChanged.subscribe((event) => {
            let _a = this.route.snapshot.queryParams, { page } = _a, params = tslib_1.__rest(_a, ["page"]);
            if (event.page !== 1)
                params.page = event.page;
            this.router.navigate([], {
                replaceUrl: true,
                relativeTo: this.route,
                queryParams: params
            });
        });
        let sort$ = this.route.queryParamMap
            .pipe(map(map => map.get('sort') || this.columns[0].key), distinctUntilChanged());
        let sortAsc$ = this.route.queryParamMap
            .pipe(map(map => map.get('sortAsc') || 'true'), distinctUntilChanged());
        combineLatest([sort$, sortAsc$]).subscribe(([sortKey, sortAsc]) => {
            let column = this.columns.find(value => value.key == sortKey);
            if (column) {
                this.sortColumn = column;
            }
            this.sortAsc = sortAsc === 'true';
            this.sortByChanged();
        });
        this.pageSizeUpdate$.pipe(takeUntil(this.onDestroy$)).subscribe((pageSize) => {
            this.pageSize = pageSize;
            this.pagination.selectPage(1);
            this.pageChange(1);
        });
    }
    sortBy(column) {
        if (this.sortColumn == column) {
            this.sortAsc = !this.sortAsc;
        }
        else {
            this.sortColumn = column;
            this.sortAsc = true;
        }
        let sortKey = this.sortColumn.key;
        this.router.navigate([], {
            queryParamsHandling: 'merge',
            replaceUrl: true,
            relativeTo: this.route,
            queryParams: { 'sort': sortKey, 'sortAsc': this.sortAsc }
        });
    }
    sortByChanged() {
        this._sites = ArrayHelper.sortBy(this._sites, this.sortAsc, this.sortColumn.property);
        this.pageChange();
    }
    pageChange(page = this.pagination.page) {
        let start = this.pageSize * (page - 1);
        let end = this.pageSize * page;
        this.pageSites = this._sites.slice(start, end);
    }
    showDeleteConfirmModal(site) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait();
            if (result) {
                this.siteDeleted.emit(site);
            }
        });
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
}
